import React, { useEffect, useState } from "react";
import Header from "./Header";
import BBox from "./BBox";
import MediaBox from "./MediaBox";
import SelectionButtons from "./SelectionButtons";
import SegmentContent from "./SegmentContent";
import LabelHeader from "./LabelHeader";
import { Box, Stack, Typography } from "@mui/material";
import { TextView } from "../../../components";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { colors } from "../../../utils";
import { ASSETS } from "../../../utils/config";
import Sidebar from "./SideBar";
import CustomLoader from "../../../sharedcomponents/CustomLoader";
import UserImage from "../../../components/UserImage";
import MediaButton from "./MediaButton";
import { useNavigate } from "react-router-dom";

function Mobile({
  data,
  wheelChildren,
  mobileContent,
  isLoading,
  showLabels,
  onClickBack,
  handleShowLabels,
  onClickNext = () => {},
  onClickPrev = () => {},
  disableNext = false,
  disablePrev = false,
  onCloseSegment = () => {},
}) {
  const nav = useNavigate();

  const [selectedButton, setSelectedButton] = useState(1);
  const [open, setOpen] = useState(false);
  const [isMediaOpen, setIsMediaOpen] = useState(false);

  const toggleMediaButton = () => {
    setIsMediaOpen(!isMediaOpen);
  };
  const [isLandscape, setIsLandscape] = useState(
    window.innerWidth > window.innerHeight
  );

  const toggleSideBar = () => {
    setOpen(!open);
  };

  useEffect(() => {
    const handleOrientationChange = () => {
      console.log("orientation changed");
      setIsLandscape(window.innerWidth > window.innerHeight);
    };

    window.addEventListener("resize", handleOrientationChange);
    return () => {
      window.removeEventListener("resize", handleOrientationChange);
    };
  }, []);

  console.log({ isLandscape });
  if (isLandscape) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          bgcolor: "#F6F7F9",
        }}
      >
        <Stack
          sx={{ justifyContent: "center", alignItems: "center", width: "50vw" }}
        >
          <img
            src={ASSETS.iyugaLogo}
            className="img-fluid"
            alt="Clones"
            width="84"
            height="84"
          />
          <Typography
            sx={{ p: 4, color: "#123051", fontSize: 20, fontWeight: "700" }}
            variant="h6"
            color="text.secondary"
            textAlign="center"
          >
            Rotate your device to portrait mode for an optimised viewing
            experience.
          </Typography>
        </Stack>
      </Box>
    );
  }

  console.log("data", data, mobileContent);

  const referral_code = data?.user_profile?.referral_code;
  function parseHTMLArray(textBodies) {
    const parser = new DOMParser();

    let results = {
      audios: [],
      documents: [],
      images: [],
      urls: [],
      videos: [],
    };

    textBodies.forEach((body) => {
      const doc = parser.parseFromString(body, "text/html");

      // Extract images
      const images = [
        ...doc.querySelectorAll('img:not([src^="static/media"])'),
      ].map((img) => img.src);
      results.images.push(...images);

      //Here i am extracting iframes to differentiate between videos and audios based on data-type attribute
      const iframes = [...doc.querySelectorAll("iframe")];
      iframes.forEach((iframe) => {
        const src = iframe.src;
        if (src.includes("youtube.com/embed")) {
          results.videos.push(src);
        } else {
          const type = iframe.getAttribute("data-type");
          const url = iframe.getAttribute("data-url");
          if (type && url) {
            if (type.includes("video")) {
              results.videos.push(url);
            } else if (type.includes("audio")) {
              results.audios.push(url);
            }
          }
        }
      });
      // Extract links for urls and documents
      const links = [...doc.querySelectorAll("a")];
      links.forEach((link) => {
        const href = link.href;
        const type = link.getAttribute("type");
        if (type === "application/pdf") {
          results.documents.push(href);
        } else if (!href.includes("iyuga-backend.s3.amazonaws.com")) {
          results.urls.push(href);
        }
      });
    });

    return results;
  }

  const { wheel_name, description, user_profile, business_box, sub_title } =
    data;

  const wheelSection = data.wheel_section || [];
  const activityWheelArray = wheelSection.length
    ? wheelSection[0]?.activity_wheel
    : [];
  const textBodies = activityWheelArray?.map((item) => item.text_body);
  const values = parseHTMLArray(textBodies);

  console.log("isMediaOpen", isMediaOpen);
  return (
    <div
      style={{
        width: "100vw",
        backgroundColor: "white",
        overflowY: "auto",
        height: "100vh",
      }}
    >
      <Sidebar
        wheel_name={wheel_name}
        authorProfile={data?.user_profile}
        referral_code={referral_code}
        open={open}
        onClose={toggleSideBar}
      />
      {isLoading ? (
        <CustomLoader show={true} />
      ) : (
        <>
          {showLabels ? (
            <LabelHeader
              onBack={onClickBack}
              onHamburgerIconClick={toggleSideBar}
            />
          ) : (
            <Header
              onHamburgerIconClick={toggleSideBar}
              wheelName={wheel_name}
              description={
                description
                  ? description
                  : user_profile?.bio
                  ? user_profile?.bio
                  : ""
              }
              subtitle={sub_title}
            />
          )}
          <Box
            sx={{
              border: "1px solid #F6F7F9",
              borderRadius: "5px",
              m: 1,
              mb: 2,
              position: "relative",
            }}
          >
            {showLabels ? null : (
              <Stack
                display={"flex"}
                flexDirection={"row"}
                justifyContent={"space-between"}
                alignItems={"center"}
                px={1}
                py={1}
                sx={{
                  position: "relative",
                  zIndex: 2, // Higher z-index for clickable elements
                }}
              >
                <Stack
                  onClick={() => handleShowLabels()}
                  display={"flex"}
                  flexDirection={"row"}
                  justifyContent={"space-around"}
                  alignItems={"center"}
                  backgroundColor={"#F6F7F9"}
                  p={1}
                  py={0.5}
                  sx={{ borderRadius: "4px" }}
                >
                  <TextView
                    onClick={() => handleShowLabels()}
                    style={{ marginRight: "6px" }}
                  >
                    Display Captions
                  </TextView>
                  <img src={ASSETS.eye} alt="eye" />
                </Stack>

                <Stack
                  display={"flex"}
                  flexDirection={"row"}
                  justifyContent={"space-between"}
                  onClick={() =>
                    nav(`/otheruserprofile/${data?.user_profile?.user_id}`)
                  }
                >
                  <UserImage
                    size={32}
                    image={data?.user_profile?.profile_image}
                  />
                  <Stack ml={1}>
                    <TextView
                      style={{
                        fontWeight: "500",
                        color: colors.primary,
                        fontSize: "14px",
                        maxWidth: "40vw",
                      }}
                    >
                      {data?.user_profile?.first_name ?? ""}{" "}
                      {data?.user_profile?.last_name ?? ""}
                    </TextView>
                    <TextView
                      style={{
                        color: "#565556",
                        fontSize: "9px",
                        marginTop: -6,
                      }}
                    >
                      Author
                    </TextView>
                  </Stack>
                </Stack>
              </Stack>
            )}
            {wheelChildren}
          </Box>
          {Object.keys(mobileContent).length !== 0 ? (
            <SegmentContent
              content={mobileContent}
              onClickNext={onClickNext}
              onClickPrev={onClickPrev}
              disableNext={disableNext}
              disablePrev={disablePrev}
              showLabels={showLabels}
              onClose={onCloseSegment}
            />
          ) : (
            <>
              {/* <SelectionButtons
                isBBoxExist={business_box}
                isMediaExist={values}
                onButtonClick={(e) => setSelectedButton(e)}
                selectedView={selectedButton}
              /> */}
              <MediaButton
                isVisible={isMediaOpen}
                onButtonClick={() => setIsMediaOpen(!isMediaOpen)}
              />
              {
                // selectedButton === 0 && business_box ? (
                //   <BBox businessBoxData={business_box} />
                // ) :
                isMediaOpen && values ? <MediaBox values={values} /> : null
              }
            </>
          )}
        </>
      )}
      <Box sx={{ height: "8vh", width: "50vw" }}></Box>
    </div>
  );
}

export default Mobile;
